import _ from '../../common/utility'
import Stickyfill from 'stickyfilljs'

function ad () {
    if (_.isCOE()) {
        Stickyfill.add($('#ads-pos-122'));

       let ad;
       if (_.getBreakpoint() === 1) {
           ad = `<li class="ad-item"><div id="ads-pos-1420-sfp" class="AdUnit AdUnit-sfp"></div></li>`;
       } else {
           ad = `<li class="ad-item"><div id="ads-pos-420-sfp" class="AdUnit AdUnit-sfp"></div></li>`;
       }

       $('.hp_bucket2col[data-track="coe-news"]')
           .find('li').eq(2).after(ad);


    }
}

export default _.catch(ad);